module.exports = __webpack_public_path__ + "img/成都办公室.4826101a.jpg";